import React from 'react';
import { Row, Col } from 'reactstrap';
import { TopBanner } from '../UIKit';
import messages from './messages';

import './sponsor.scss';

const sponsor = props => {
  const bannerMsg = messages.sponsor;

  const html = `${bannerMsg.defaultMessage + ' '}
                <a href='${bannerMsg.anchorTarget}' target='_blank' aria-label="${bannerMsg.anchorMessage}">
                    ${bannerMsg.anchorMessage}
                </a> `;
  return (
    <Row id="SponsorBanner" className={'no-gutters alert-warning'}>
      <Col md={12}>
        <div className="text-center">
          <TopBanner html={html} />
        </div>
      </Col>
    </Row>
  );
};

export default sponsor;
